import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCreditCard = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M17.067 24.533h-6.4V22.4h6.4zm-8.534 0H4.267V22.4h4.266zm-5.866 2.134h26.666a.531.531 0 0 0 .534-.534V16H2.133v10.133c0 .297.237.534.534.534zM29.333 5.333H2.667a.531.531 0 0 0-.534.534V9.6h27.734V5.867a.531.531 0 0 0-.534-.534zM2.667 3.2h26.666A2.674 2.674 0 0 1 32 5.867v20.266a2.674 2.674 0 0 1-2.667 2.667H2.667A2.674 2.674 0 0 1 0 26.133V5.867A2.674 2.674 0 0 1 2.667 3.2z" /></svg>;
export default SvgCreditCard;